import React from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";

const About = () => {
  return (
    <Container maxWidth="lg" sx={{ marginTop: 4 }}>
      <Typography variant="h2" gutterBottom align="center">
        About Us
      </Typography>
      <Typography variant="body1" paragraph align="center">
        Welcome to our application! We are dedicated to providing the
        bestenjoyable. service for our users. Our goal is to make your
        experience seamless and enjoyable.
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardMedia
              component="img"
              height="140"
              image="https://via.placeholder.com/300"
              alt="Team Member"
            />
            <CardContent>
              <Typography variant="h5">Our Mission</Typography>
              <Typography variant="body2" color="text.secondary">
                To be a leading platform in our industry, recognized for our
                commitment to excellence.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Card>
            <CardMedia
              component="img"
              height="140"
              image="https://via.placeholder.com/300"
              alt="Team Member"
            />
            <CardContent>
              <Typography variant="h5">Our Vision</Typography>
              <Typography variant="body2" color="text.secondary">
                To be a leading platform in our industry, recognized for our
                commitment to excellence.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default About;
